import styles from "./index.module.scss";

export default function LandingView() {
  return <iframe src="https://www.stafflow.by/360" className={styles.frame} title="https://www.stafflow.by/360" />;
}
